import React from 'react'
import { useHistory } from 'react-router-dom'

import ContentBodyHeader, {
  IButton,
} from '@/Components/ResourcesCncPageComponents/ContentBodyHeader/ContentBodyHeader'
import useTranslation from '@/Hooks/UseTranslation'
import { useProject } from '@/Hooks/UseProject'

import './ProjectOverviewHeader.scss'

type OverviewTab = 'dashboard' | 'indicators'

interface Props {
  activeTab: OverviewTab
  buttons?: IButton[]
}

const ProjectOverviewHeader = ({ activeTab, buttons }: Props) => {
  const history = useHistory()
  const { t } = useTranslation()
  const { project_id } = useProject()

  const handleChangeTab = (tab: string) => {
    if (!project_id || tab === activeTab) return

    history.push(
      tab === 'indicators'
        ? `/project/${project_id}/indicators/ppc`
        : `/project/${project_id}/`,
    )
  }

  return (
    <ContentBodyHeader
      className="project-overview-header"
      title={t('PROJECT_OVERVIEW:PageTitle')}
      buttons={buttons}
      tabs={[
        {
          key: 'dashboard',
          label: t('NAVIGATION:ProjectDashboard'),
          icon: <span className="icon-dashboard" />,
        },
        {
          key: 'indicators',
          label: t('NAVIGATION:Indicators'),
          icon: <span className="icon-indicadores" />,
        },
      ]}
      activeTabKey={activeTab}
      onChangeTab={handleChangeTab}
    />
  )
}

export default ProjectOverviewHeader
